// Trạng thái "Tố giác & Góp ý" cho cổng menu và viên đỏ trên thanh bên.
//
// Cổng menu là hàm thường (không gọi hook được) nên đọc kho này đồng bộ; kho
// được nạp bởi useSealedInboxMeSync (api.ts) ở useSidebarData — cùng khuôn với
// features/kho/flag.ts. Tệp này KHÔNG được nhập máy khách API: cổng menu còn
// chạy trong kịch bản dựng bộ hướng dẫn (node, không có import.meta.env).
import { create } from "zustand";

export interface SealedInboxFlag {
  /** Máy chủ đã đặt SEALED_INBOX_KEY — tắt thì cả hai mục menu ẩn. */
  enabled: boolean;
  /** Có tên trong danh sách người đọc hộp thư. */
  isReader: boolean;
  /** Tổng giám đốc trong hệ thống: thấy tên người gửi kín danh, quyết thưởng. */
  seesSender: boolean;
  /** Thư kín danh của tôi có phản hồi chưa xem (thư ẩn danh không nối với ai). */
  senderUnread: number;
  /** Thư mới hoặc có bổ sung, với người đọc. */
  readerUnread: number;
}

export const SEALED_INBOX_OFF: SealedInboxFlag = {
  enabled: false,
  isReader: false,
  seesSender: false,
  senderUnread: 0,
  readerUnread: 0,
};

interface State extends SealedInboxFlag {
  set: (v: SealedInboxFlag) => void;
}

export const useSealedInboxFlag = create<State>((set) => ({
  ...SEALED_INBOX_OFF,
  set: (v) => set(v),
}));
